<template>
  <div style="">
    <div id="action">
      <div class="btn-group btn-group-justified">
        <!-- <button  class="btn btn-outline-primary">دانلود</button> -->
        <button
          style="width: 120px"
          @click="print"
          class="btn btn-outline-primary"
        >
          چاپ
        </button>
        <button style="width: 120px" class="btn btn-outline-primary">
          صفحه اصلی
        </button>
      </div>
    </div>
    <div v-show="noneDisplay"  id="tickets">
      <div id="hotel-ticket">
        <div
          style="
            font-size: 11pt !important;
            direction: rtl;
            display: flex;
            border: 1px solid;
            padding: 15px;
          "
        >
          <div style="width: 25%">
            <img
              width="190"
              height="60"
              src="../../../public/img/pdk_logo_small.png"
            />
          </div>
          <div
            style="
              direction: ltr !important;
              width: 75%;
              display: grid;
              text-align: left;
            "
          >
            <label
              >Reserve Number : {{ onTickets.tickets.reserveNumber }} (PMS:{{
                onTickets.tickets.pmsReserveNumber
              }})
            </label>
            <!-- <label>Reservation Number: <span>{{onTickets.tickets[0].reserveNumber}}</span></label> -->
            <label
              >Issue Date:
              <span>{{ onTickets.tickets.shamsiDate }}</span></label
            >
          </div>
        </div>

        <div class="pass">هتل</div>

        <div
          style="
            font-size: 12pt !important;
            display: flex;
            border: 1px solid;
            padding: 20px;
          "
        >
          <div
            class="row"
            style="
              direction: rtl;
              text-align: initial;
              display: flex;
              width: 100%;
            "
            id="hotel"
          >
            <strong style="margin-bottom: 5px; margin-right: 1%; width: 100%">
              {{ onTickets.tickets.hotel.title }}</strong
            >

            <label style="margin-right: 1%; width: 100%"
              ><strong>نشانی :</strong>
              {{ onTickets.tickets.hotel.address }}</label
            >
            <br />
            <div style="display: contents" id="time">
              <label style="margin-right: 1%"
                ><strong>تاریخ ورود:</strong>
                {{ onTickets.tickets.shamsiArrivalDate }}</label
              >

              <label style="margin-right: 6%"
                ><strong>تاریخ خروج:</strong>
                {{ onTickets.tickets.shamsiDepartureDate }}</label
              >
            </div>
            <br />
            <div
              style="
                font-size: 12pt !important;
                direction: rtl;
                text-align: initial;
                margin-top: 20px;
              "
              class="container"
            >
              <table class="table table-centered">
                <tbody>
                  <tr style="border-bottom: 1px solid">
                    <td>اتاق</td>
                    <td>تعداد اتاق</td>
                    <td>بزرگسال</td>
                    <td>کودک</td>
                    <td>تعداد تخت اضافه</td>
                    <td></td>
                  </tr>
                  <tr
                    v-for="(room, index) in onTickets.roomDetails"
                    :key="index"
                  >
                    <td>{{ room.description }}</td>
                    <td>{{ room.numberOfRooms }}</td>
                    <td>{{ room.adult }}</td>
                    <td>{{ room.child }}</td>
                    <td>{{ room.numberOfExtraBed }}</td>

                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="pass">مشخصات رزرو کننده و مسافرین</div>

        <div
          style="
            font-size: 12pt !important;
            direction: rtl;
            text-align: initial;
            border: 1px solid;
            padding: 20px;
          "
        >
          <label style="margin-right: 1%; width: 100%"
            ><span>نام و نام خانوادگی :</span
            >{{ onTickets.tickets.customerFullName }}</label
          >
          <br />
          <div style="margin-right: 1%; display: contents" id="time">
            <label style="margin-right: 1%"
              ><span>شماره تماس:</span> {{ onTickets.tickets.mobile }}</label
            >

            <label style="margin-right: 6%"
              ><span>پست الکترونیک:</span> {{ onTickets.tickets.email }}</label
            >
          </div>
          <br />
          <label style="margin-right: 1%"
            ><span>نشانی:</span> {{ onTickets.tickets.address }}</label
          >
          <br />
          <label style="margin-right: 1%"
            ><span>مشخصات مسافرین:</span>
            <div
              style="margin-right: 1%; display: contents"
              v-for="(passenger, index) in onTickets.passengers"
              :key="index"
            >
              <span>
                {{ passenger.name }} &nbsp; {{ passenger.lastName }}
                <span style="font-size: 12px"
                  >({{ passenger.nationalId }} )
                </span></span
              >
              <span v-if="index !== onTickets.passengers.length - 1">-</span>
            </div>
          </label>

          <div
            style="
              direction: rtl;
              margin-top: 3px;
              margin-bottom: 20px;
              text-align: initial;
              font-size: 12px;
            "
          >
            <strong style="margin-right: 1%">درخواست مسافر:</strong>
            <span>{{ onTickets.tickets.customerRequest }}</span>
          </div>

          <label
            v-if="onTickets.tickets.bookingTransfer.length > 0"
            style="margin-right: 1%"
            ><strong>اطلاعات ترانسفر:</strong>
            <div
              style="margin-right: 1%; display: contents"
              v-for="(item, index) in onTickets.transferInfo"
              :key="index"
            >
              <label> وسیله سفر - <span>هواپیما</span></label>
              <label style="margin-right: 1%">
                تاریخ سفر - <span>{{ item.arrivalDateShamsi }}</span></label
              >
              <label style="margin-right: 1%">
                ساعت سفر - <span>{{ item.arrivalTime }}</span></label
              >
              <label style="margin-right: 1%">
                توضیحات سفر - <span>{{ item.arrivalDescription }}</span></label
              >
              <label style="margin-right: 1%">
                تاریخ برگشت - <span>{{ item.departureDateShamsi }}</span></label
              >
              <label style="margin-right: 1%">
                ساعت برگشت - <span>{{ item.departureTime }}</span></label
              >
              <label style="margin-right: 1%">
                توضیحات برگشت -
                <span>{{ item.departureDescription }}</span></label
              >
            </div>
          </label>
        </div>

        <div class="pass">قوانین و مقررات</div>

        <div
          style="
            direction: rtl;
            border: 1px solid black;
            padding: 6px;
            text-align: right;
          "
        >
          <div
            style="
              font-size: 11pt !important;
              margin-bottom: 10px;
              margin-right: 1%;
              display: contents;
            "
            id="time"
          >
            <label style="margin-right: 1%"
              ><span>زودترین ساعت تحویل اتاق:</span>
              {{ onTickets.tickets.hotel.checkinFrom.substring(0, 5) }}</label
            >

            <label style="margin-right: 3%"
              ><span>دیرترین ساعت تخلیه اتاق :</span>
              {{ onTickets.tickets.hotel.checkoutTo.substring(0, 5) }}</label
            >
            <label style="margin-right: 3%"
              ><span>مهلت کنسلی رزرو قبل از ورود :</span
              >{{ onTickets.tickets.hotel.cancelTerm }}<span>روز</span>
            </label>
          </div>
          <br />
          <strong style="font-size: 11pt !important; margin-right: 1%"
            >میهمان گرامی :
          </strong>
          <p
            v-html="onTickets.tickets.hotel.policy"
            style="margin-right: 1%; font-size: 11pt !important"
          ></p>
        </div>

        <div class="pass">شرایط لغو</div>
        <div style="border: 1px solid black; padding: 6px; text-align: right">
          <p
            v-html="onTickets.tickets.hotel.termCond"
            style="direction: rtl; font-size: 11pt !important"
          ></p>
        </div>

        <div class="pass">خدمات هتل</div>
        <div style="border: 1px solid black; padding: 6px; text-align: right">
          <p
            v-html="onTickets.tickets.hotel.voucherText"
            style="direction: rtl; font-size: 11pt !important"
          ></p>
        </div>
      </div>
      <footer>
        <div style="direction: rtl">
          <label style="float: right; direction: rtl; font-size: 14px"
            ><span>کاربر ثبت کننده :</span
            >{{ onTickets.tickets.sourceUserName }}</label
          >
          <!-- <label  style="float:left;direction: rtl;font-size:13px">{{onTickets.tickets[0].reserveNumber}}</label> -->
        </div>
      </footer>
    </div>
  </div>
</template>
<script>
export default {
  name: "TicketAction",

  components: {},
  props: {
    tickets: { type: Object, default: () => ({}) },
  },
  data: () => ({
    noneDisplay: false,
  }),
  created() {},
  computed: {
    onTickets() {
      return (this.tickets = this.tickets);
    },
  },
  methods: {
    getAirLineLogoUrl(name) {
      return "../img/airlines/" + name + ".png";
    },
    print() {
      const localOptions = {
        styles: [
          "https://dariushgroup.com/css/bootstrap.css",
          "https://dariushgroup.com/css/printTicket.css",
        ],
      };
      this.$htmlToPaper("tickets", localOptions, () => {
        console.warn("done landscape");
      });
    },
  },
};
</script>

<style lang="scss" scoped>

#action {
  text-align: center;
  margin-top: 20px;
}
</style>